<p>Now Playing {{epno}} </p>

<!--
<vg-player>
  <vg-controls>
      <vg-play-pause></vg-play-pause>
      <vg-playback-button></vg-playback-button>

      <vg-time-display vgProperty="current" vgFormat="mm:ss"></vg-time-display>

      <vg-scrub-bar>
          <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
          <vg-scrub-bar-buffering-time></vg-scrub-bar-buffering-time>
      </vg-scrub-bar>

      <vg-time-display vgProperty="total" vgFormat="mm:ss"></vg-time-display>

      <vg-mute></vg-mute>
      <vg-volume></vg-volume>

      <vg-fullscreen></vg-fullscreen>
  </vg-controls>

  <video #media [vgMedia]="$any(media)" id="singleVideo" preload="auto" crossorigin>
      <source src="{{play}}" type="video/mp4">
  </video>
</vg-player>
 -->
 <vg-player>
  <video [vgMedia]="$any(media)" #media id="singleVideo" preload="auto" controls>
      <source src="{{play}}" type="video/mp4">
  </video>
</vg-player>
